const IS_LIVE = true;

const LOCAL_API_BASE_URL = 'https://htally.com';
const LIVE_API_BASE_URL = '';

export const environment = {
  isLive: IS_LIVE,
  apiBaseUrl: IS_LIVE ? LIVE_API_BASE_URL : LOCAL_API_BASE_URL
};
